export default {
    methods: {
        mergeAuthors( product ) {
            const allAuthors = product.bundles.reduce(( authors, product ) => {
                return authors.concat( product.authors )
            }, [])

            const uniqueAuthors = allAuthors.reduce(( uniqueAuthors, author ) => {
                if ( !uniqueAuthors.find( a => a.id === author.id )) {
                    uniqueAuthors.push( author )
                }

                return uniqueAuthors

            }, [])
            
            return uniqueAuthors
        },
        backToShopping() {
            window.history.back()
        },
        getCountries() {
            return [
                {
                    id: 1,
                    title: 'Slovensko'
                }, {
                    id: 2,
                    title: 'Česko'
                }
            ]
        },
        getPhonePrefixes() {
            return [
                {
                    title: 'SK (+421)',
                    prefix: '+421'
                }, {
                    title: 'ČR (+420)',
                    prefix: '+420'
                }
            ]
        },
        getPriceOutOfScopeShippingOrPayment() {
            return [
                {
                    title: 'Použiť cenu z najvyššie zadefinovaného rozsahu',
                    value: 1
                }, {
                    title: 'Vypnúť možnosť dopravy alebo platby',
                    value: 0
                }
            ]
        },
        showAddedToCartPopup( html ) {
            document.getElementById('popup-wrapper').innerHTML = html
        }
    }
}